// Tickable Mail: common texts (nl)
export default {
  "mail_menu_setup": "Instellen",
  "mail_actions_title": "Wat wil je doen?",
  "mail_reach_sentence": "Nog niemand in je publiek. Kopers komen er vanzelf bij. | 1 persoon in je publiek, {consent} wil je nieuws ontvangen. | {people} mensen in je publiek, {consent} willen je nieuws ontvangen.",
  "mail_action_news": "Nieuwsbrief sturen",
  "mail_action_news_text": "Vertel over je volgende activiteit, aan iedereen die je nieuws wil.",
  "mail_action_inbox": "Berichten",
  "mail_action_inbox_unread": "1 nieuw bericht | {n} nieuwe berichten",
  "mail_action_inbox_text": "Reacties van bezoekers op je mails, op één plek.",
  "mail_action_people": "Bezoekers",
  "mail_action_people_text": "Iedereen die bij je kocht, wat ze kochten en wie je nieuws wil.",
  "mail_system_order_cancelled": "Annulering",
  "mail_system_order_refunded": "Terugbetaling",
  "mail_system_extras_bought": "Extra bijgekocht",
  "mail_switch_safe": "Geen zorgen: er verandert niks tot jij iets aanzet. En terug kan altijd.",
  "mail_next_title": "Voor je klaargezet",
  "mail_next_all_good": "Alles loopt lekker",
  "mail_next_all_good_text": "Er wacht niks op je. Je mails gaan vanzelf de deur uit.",
  "mail_next_replies": "1 reactie wacht op je | {n} reacties wachten op je",
  "mail_next_replies_text": "Bezoekers hebben gereageerd. Je antwoord komt gewoon in hun mailbox.",
  "mail_next_to_inbox": "Naar je berichten",
  "mail_next_reminder": "Je herinnering staat klaar",
  "mail_next_reminder_text": "Twee dagen voor het bezoek krijgen je bezoekers alles op een rij. Hij staat nog uit.",
  "mail_next_thanks": "Je bedankje staat klaar",
  "mail_next_thanks_text": "Na afloop een bedankje, alleen voor wie er echt was. Het staat nog uit.",
  "mail_next_turn_on": "Aanzetten",
  "mail_next_look_first": "Eerst bekijken",
  "mail_next_news": "1 persoon wil je nieuws | {n} mensen willen je nieuws",
  "mail_next_news_text": "Vertel ze over je volgende activiteit, met een nieuwsbrief.",
  "mail_next_news_action": "Nieuwsbrief maken",
  "mail_title": "Publiek",
  "mail_overview": "Overzicht",
  "mail_flows": "Automatische mails",
  "mail_campaigns": "Nieuwsbrieven",
  "mail_templates": "Ontwerpen",
  "mail_contacts": "Bezoekers",
  "mail_inbox": "Berichten",
  "mail_settings": "E-mailinstellingen",
  "settings_mail": "E-mail",
  "mail_settings_to_mail": "Naar Mail →",
  "mail_overview_classic_intro": "Je ticketmails gaan nu nog als standaardmail. Zet je eigen mails aan en maak ze helemaal van jou.",
  "mail_overview_on_intro": "De mensen die naar je activiteiten komen, en hoe je ze bereikt.",
  "mail_switch_what_title": "Dit krijg je erbij",
  "mail_benefit_design_title": "Je eigen mails",
  "mail_benefit_design": "Jouw logo, jouw kleuren, jouw woorden.",
  "mail_benefit_flows_title": "Automatische mails",
  "mail_benefit_flows": "Een herinnering vooraf, een bedankje achteraf.",
  "mail_benefit_campaigns_title": "Nieuwsbrieven",
  "mail_benefit_campaigns": "Vertel je bezoekers over je volgende activiteit.",
  "mail_benefit_inbox_title": "Berichten",
  "mail_benefit_inbox": "Antwoorden van bezoekers komen gewoon hier binnen.",
  "mail_switch_needs_slug": "Om over te stappen heeft je organisatie een webadres (slug) nodig, daar komt je afzenderadres op.",
  "mail_switch_set_slug": "Stel je webadres in",
  "mail_switch_button": "Eigen mails aanzetten",
  "mail_switch_consent_now": "Alvast toestemming vragen in je shop",
  "mail_switched": "Je bent overgestapt",
  "mail_switched_detail": "Kijk even rond: je automatische mails staan klaar, maar staan nog uit.",
  "mail_switch_failed": "Aanzetten lukte niet",
  "mail_to": "Aan",
  "mail_subject": "Onderwerp",
  "mail_status": "Status",
  "mail_when": "Wanneer",
  "mail_status_queued": "Gaat zo de deur uit",
  "mail_status_sending": "Wordt verstuurd",
  "mail_status_sent": "Verstuurd",
  "mail_status_delivered": "Afgeleverd",
  "mail_status_skipped": "Overgeslagen",
  "mail_status_failed": "Mislukt",
  "mail_status_bounced": "Kwam niet aan",
  "mail_status_complained": "Gemeld als spam",
  "mail_skip_wait_passed": "Het moment was al voorbij",
  "mail_skip_no_consent": "Geen toestemming voor nieuwsmail",
  "mail_skip_unsubscribed": "Afgemeld",
  "mail_skip_bounced": "Dit adres werkt niet",
  "mail_skip_frequency_cap": "Er ging vandaag al een nieuwsmail naar dit adres",
  "mail_skip_order_gone": "De bestelling bestaat niet meer",
  "mail_skip_order_unpaid": "De bestelling is niet betaald",
  "mail_skip_already_paid": "Al betaald",
  "mail_skip_refunded": "Terugbetaald",
  "mail_skip_no_discount": "Geen korting gekoppeld aan het codeblok",
  "mail_skip_blocked_content": "Niet verstuurd: inhoud tegengehouden",
  "mail_system_order_confirmation": "Ticketbevestiging",
  "mail_system_voucher": "Tegoedbon",
  "mail_system_reservation_payment": "Betaallink reservering",
  "mail_system_signup_confirm": "Aanmelding bevestigen",
  "mail_system_waitlist_joined": "Op de wachtlijst",
  "mail_system_waitlist_offer": "Plek vrij op de wachtlijst",
  "mail_system_waitlist_open": "Weer tickets voor de wachtlijst",
  "mail_system_manage_code": "Code om je bestelling aan te passen",
  "mail_system_manual_html": "Antwoord uit Berichten",
  "notification_type_mail_reply": "Nieuw bericht van een bezoeker",
  "notification_type_mail_reply_description": "Een bezoeker reageerde op een mail",
  "notification_type_mail_flow": "Melding uit een automatische mail",
  "notification_type_mail_flow_description": "Een automatische mail met een 'Melding'-stap wil je iets laten weten",
  "notification_type_self_service": "Annuleringen door bezoekers",
  "notification_type_self_service_description": "Een bezoeker annuleerde zelf, met of zonder geld terug. Lukte terugbetalen niet, dan zie je dat hier.",
  "notification_type_payout": "Uitbetalingen",
  "notification_type_payout_description": "Een mailtje bij elke uitbetaling: hoeveel er onderweg is en wanneer het op je rekening staat",
  "notification_type_organizer_tips": "Tips en herinneringen van Tickable",
  "notification_type_organizer_tips_description": "Een tip die past bij hoe je verkoopt (hooguit eens per twee weken), en herinneringen zoals 'de verkoop start bijna' en 'bijna uitverkocht'",
  "mail_system_cancellation_choice": "Keuze na een annulering",
  "mail_system_order_voucher": "Tegoedbon na een annulering",
  "mail_overview_people": "Nog niemand. Kopers komen er vanzelf bij. | 1 bezoeker | {n} bezoekers",
  "mail_overview_consent": "nog niemand wil je nieuws | 1 wil je nieuws | {n} willen je nieuws",
  "mail_overview_see_all": "Alles bekijken",
  "mail_overview_groups_hint": "Je volgende nieuwsbrief kan naar precies zo'n groep.",
  "mail_overview_waiting": "Wacht op jou",
  "mail_overview_replies": "1 reactie | {n} reacties",
  "mail_overview_reply": "Beantwoorden",
  "mail_overview_automatic": "Gaat vanzelf",
  "mail_overview_ticket_mail": "Ticketmail",
  "mail_overview_ticket_mail_when": "Meteen na het kopen, altijd.",
  "mail_overview_look": "Bekijken",
  "mail_overview_last_news": "Laatste nieuwsbrief",
  "mail_overview_preview_caption": "Je eigen ticketmail, met je logo en kleur uit je shop",
  "mail_overview_switch_gets": "Een herinnering vooraf, een bedankje achteraf, en antwoorden die hier binnenkomen.",
  "mail_overview_test_me": "Eerst een testmail naar mij",
}
